module.exports = __webpack_public_path__ + "img/34a-config-modelos-doc-wizard-params.787d08d0.png";